import { CollectibleId_Schema } from "@/services/collectibles";
import { PublicCollectionItem_Basics_Schema } from "@/services/collection/item/public/publicCollectionItemSchemaPartials";
import { ShippingMethodId_Schema } from "@/services/marketplace/shippingMethod";
import { PriceNumeric_Schema } from "@/services/prices";
import { UserPublicInfo_Schema } from "@/services/user";
import { DateTimeObject_Schema, WholeNumber_Schema } from "@/utilities";
import { z } from "zod";

export const MarketplaceItemId_Schema = WholeNumber_Schema;

export const MarketplaceItem_Schema = z
  .object({
    collectible: z
      .object({
        id: CollectibleId_Schema,
        name: z.string(),
      })
      .nullable(),
    collectionItem: PublicCollectionItem_Basics_Schema,
    id: MarketplaceItemId_Schema,
    delivery: z.object({
      id: z.number().int().positive(),
      delivery: ShippingMethodId_Schema,
      price: PriceNumeric_Schema,
      numberPerDelivery: z.number().int().min(1),
    }),
    itemPrice: z.object({
      id: z.number().int().positive(),
      price: PriceNumeric_Schema,
    }),
    name: z.string(),
    note: z.string(),
    quantity: z.number().int().min(0),
    createdDateTime: DateTimeObject_Schema,
    user: UserPublicInfo_Schema,
  })
  .transform((response) => ({
    id: response.id,
    name: response.name,
    collectible: response.collectible,
    collectionItem: response.collectionItem,
    categoryId: response.collectionItem.categoryId,
    price: response.itemPrice.price,
    priceId: response.itemPrice.id,
    priceBeforeConversion: response.itemPrice.price, // @todo should be sent from API
    description: response.note,
    images: response.collectionItem.images,
    createdDateTime: response.createdDateTime,
    possibleShippings: [
      {
        id: response.delivery.id,
        shippingMethodId: response.delivery.delivery,
        price: response.delivery.price,
        quantityPerPackage: response.delivery.numberPerDelivery,
      },
    ],
    quantity: response.quantity,
    owner: response.user,
  }));

export const MarketplaceItemPreview_Schema = z.object({
  id: MarketplaceItemId_Schema,
  name: z.string(),
  price: PriceNumeric_Schema,
  quantity: WholeNumber_Schema,
});
